// Messages for portal/Invoices (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'portal.invoices.head': 'Invoices — Portal',
  'portal.invoices.title': 'Invoices',
  'portal.invoices.desc': 'Your invoices from Geo4Logistics',
  'portal.invoices.col.invoice': 'Invoice',
  'portal.invoices.col.shipment': 'Shipment',
  'portal.invoices.col.issued': 'Issued',
  'portal.invoices.col.due': 'Due',
  'portal.invoices.col.total': 'Total',
  'portal.invoices.download_aria': 'Download invoice {number} (PDF)',
  'portal.invoices.empty.title': 'No invoices yet',
  'portal.invoices.empty.body':
    'When Geo4Logistics issues an invoice for one of your shipments, it’ll appear here and you’ll be notified.',
}

export const zhTW = {
  'portal.invoices.head': '發票 — 客戶入口',
  'portal.invoices.title': '發票',
  'portal.invoices.desc': '來自 Geo4Logistics 的發票',
  'portal.invoices.col.invoice': '發票',
  'portal.invoices.col.shipment': '貨件',
  'portal.invoices.col.issued': '開立日期',
  'portal.invoices.col.due': '到期日',
  'portal.invoices.col.total': '總計',
  'portal.invoices.download_aria': '下載發票 {number}（PDF）',
  'portal.invoices.empty.title': '尚無發票',
  'portal.invoices.empty.body': '當 Geo4Logistics 為您的貨件開立發票時，將會顯示在此並通知您。',
}
